import TrackingUtils from "@tracking/utils/TrackingUtils";

export const dataOcorrensReducer = (state, action) => {
  state.items = action.payload.responseData.items;

  const itemsVariaveis = [...action.payload.responseVariaveis.items].sort(
    (x, y) => TrackingUtils.sortAlpha(x, y, "descricao")
  );

  state.itemsVariaveis = itemsVariaveis;

  state.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: action.payload.responseData.totalPaginas,
    totalItems: action.payload.responseData.totalRegistros,
  };

  state.requestGetParams = action.meta.arg;
};
